export default function reducerDashboard(state = {}, action) {
  switch (action.type) {
    case 'GET_DASHBOARD_SUMMARY':
      return {
        ...state,
        summary: action.payload.data,
      }
    case 'GET_DASHBOARD_TIMESERIES':
      return {
        ...state,
        timeseries: action.payload.data,
      }
    default:
      return state
  }
}
